import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
export default forwardRef((props, ref) => jsx("svg", {
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -0.5 21 21",
    ref,
    ...props,
    dangerouslySetInnerHTML: { __html: '<path d="M15.409 10 4.992 4.792v10.416L15.409 10Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />' }
  })
);